<template>
  <div class="feature-app-showcase section-space--pt_15" id="service">
    <div class="container mb-30">
      <b-alert show class="mt-15 mb-20 col-lg-6 mx-auto text-center">Objednávky , infomace a konzultace<br/> na tel: <strong>603 918 213</strong> každý den 7:00 - 18:00<br /><a href="mailto:dezinfekce@dezinfekcepotrubi.cz" class="font-weight-bold">dezinfekce@dezinfekcepotrubi.cz</a></b-alert>
      <FeatureApp class="mb-30"/>
    </div>
  </div>
</template>

<script>
import FeatureApp from '../components/FeatureApp'

export default {
  name: 'FeatureAppShowcase',
  components: {
    FeatureApp,
  }
};
</script>

<style lang="scss">

</style>